import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { CircularProgress } from "@mui/material";

const AuroraButton = ({
  children,
  onClick,
  type = "button",
  fullWidth = false,
  loading = false,
  disabled = false,
  variant = "contained",
  icon,
  sx = {},
}) => {
  const isOutlined = variant === "outlined";

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      whileHover={!disabled && !loading ? { scale: 1.02, y: -1, boxShadow: "0 0 20px rgba(34, 211, 238, 0.6)" } : undefined}
      whileTap={!disabled && !loading ? { scale: 0.98 } : undefined}
      transition={{
        type: "spring",
        stiffness: 400,
        damping: 25,
      }}
      style={{
        width: fullWidth ? "100%" : "auto",
        border: isOutlined ? "1px solid color-mix(in srgb, var(--text-primary) 15%, transparent)" : "none",
        outline: "none",
        cursor: disabled ? "not-allowed" : "pointer",
        borderRadius: "10px",
        background: disabled
          ? "color-mix(in srgb, var(--text-primary) 5%, transparent)"
          : isOutlined
            ? "transparent"
            : "#6366f1",
        color: disabled
          ? "color-mix(in srgb, var(--text-primary) 30%, transparent)"
          : isOutlined
            ? "var(--text-primary)"
            : "#ffffff",
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        fontSize: "0.875rem",
        padding: "12px 28px",
        position: "relative",
        boxShadow: disabled || isOutlined ? "none" : "0 4px 14px 0 rgba(99, 102, 241, 0.39)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.6rem",
        textTransform: "none",
        letterSpacing: "0.01em",
        transition: "all 0.2s ease",
        ...sx,
      }}
    >
      {!loading && icon}
      {loading && (
        <CircularProgress
          size={20}
          sx={{ color: isOutlined ? "var(--text-primary)" : "var(--mui-palette-background-default)", position: "absolute", left: "calc(50% - 10px)" }}
        />
      )}
      <span style={{ opacity: loading ? 0 : 1 }}>{children}</span>
    </motion.button>
  );
};

AuroraButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit"]),
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["contained", "outlined"]),
  icon: PropTypes.node,
  sx: PropTypes.object,
};

export default AuroraButton;
